import { Card, Col, Row } from 'react-bootstrap';

import { ControlledTerm } from './ControlledTerm';
import { type DOI } from './utils/doi';

export function DOIExternalReferences({ doi }: { doi: DOI }) {
  if (!doi.techniques?.length && !doi.classifications?.length) {
    return null;
  }

  return (
    <Card className="h-100">
      <Card.Header className="p-2">External References</Card.Header>
      <Card.Body className="p-2">
        <Row className="g-2">
          {!!doi.techniques?.length && (
            <Col xs={12} sm={6}>
              <strong>Experimental technique</strong>
              {doi.techniques.map((term) => (
                <ControlledTerm
                  key={`${term.scheme}-${term.name}`}
                  term={term}
                />
              ))}
            </Col>
          )}
          {!!doi.classifications?.length && (
            <Col xs={12} sm={6}>
              <strong>Instrument type</strong>
              {doi.classifications.map((term) => (
                <ControlledTerm
                  key={`${term.scheme}-${term.name}`}
                  term={term}
                />
              ))}
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
}
